// TO DO: Move hotspotData to database
export const hotspotData = [
  {
    id: 1,
    shopId: 4,
    collection: "sofas",
    name: "Sloan 5-Piece Sectional",
    price: 2190,
    thumbnail: "/shop/sofas/shop_sofas_04_thumb.jpg",
    coordinates: {
      mobile: { x: 71, y: 47 },
      tablet: { x: 42, y: 40 },
      desktop: { x: 43, y: 40 },
    },
  },
  {
    id: 2,
    shopId: 34,
    collection: "tables",
    name: "Ravi Coffee Table",
    price: 299,
    thumbnail: "/shop/tables/shop_tables_34_thumb.jpg",
    coordinates: {
      mobile: { x: 87, y: 68 },
      tablet: { x: 50.5, y: 64 },
      desktop: { x: 50.5, y: 64 },
    },
  },
  {
    id: 3,
    shopId: 58,
    collection: "decor",
    name: "Hand-Knit Boho Pillow Cover",
    price: 39,
    thumbnail: "/shop/decor/shop_decor_58_thumb.jpg",
    coordinates: {
      mobile: { x: 85, y: 48.5 },
      tablet: { x: 61.5, y: 42.5 },
      desktop: { x: 59.5, y: 42.5 },
    },
  },
  {
    id: 4,
    shopId: 71,
    collection: "chairs",
    name: "Sloan Armchair",
    price: 179,
    thumbnail: "/shop/chairs/shop_chairs_71_thumb.jpg",
    coordinates: {
      mobile: { x: 23, y: 73 },
      tablet: { x: 17, y: 68 },
      desktop: { x: 23, y: 68 },
    },
  },
  {
    id: 5,
    shopId: 57,
    collection: "decor",
    name: `"Divided By 3" Abstract Wall Art`,
    price: 199,
    thumbnail: "/shop/decor/shop_decor_57_thumb.jpg",
    coordinates: {
      mobile: { x: 66.5, y: 24 },
      tablet: { x: 46.5, y: 18 },
      desktop: { x: 47.3, y: 18 },
    },
  },
  {
    id: 6,
    shopId: 24,
    collection: "lighting",
    name: "White Terrazzo Table\u00A0Lamp",
    price: 159,
    thumbnail: "/shop/lighting/shop_lighting_24_thumb.jpg",
    coordinates: {
      mobile: { x: 11, y: 32 },
      tablet: { x: 8.5, y: 23 },
      desktop: { x: 16, y: 23 },
    },
  },
];
